var _module_exports = "<iframe style=\"display:none\" id=\"autoalertiframe\" class=\"hidden-iframe iframe-autoalert new-page\" ng-src=\"{{$ctrl.iframeSource}}\"></iframe>";;
var path = '/app/components/legacy-iframe-support.component.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;